// 表头配置
export const tableHeader = {
  workbench: [
    {
      label: '状态',
      prop: 'status',
      width: 100,
      isShow: true,
      index: 0,
    },
    {
      label: '姓名',
      prop: 'patientName',
      width: 100,
      isShow: true,
      index: 1,
    },
    {
      label: '性别',
      prop: 'patientGender',
      width: 100,
      isShow: true,
      index: 2,
    },
    // 年龄
    {
      label: '年龄',
      prop: 'patientAge',
      width: 100,
      isShow: true,
      index: 3,
    },
    // 设备类型
    {
      label: '设备类型',
      prop: 'deviceType',
      width: 100,
      isShow: true,
      index: 4,
    },
    // 检查部位
    {
      label: '检查部位',
      prop: 'bodyPartExamined',
      width: 100,
      isShow: true,
      index: 5,
    },
    // 上传时间
    {
      label: '上传时间',
      prop: 'uploadTime',
      width: 100,
      isShow: true,
      index: 6,
    },
    // 检查时间
    {
      label: '检查时间',
      prop: 'studyTime',
      width: 100,
      isShow: true,
      index: 7,
    },
  ],
};
